module.exports = "my-footer {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0; }\n\n.inverse {\n  position: absolute;\n  pointer-events: none;\n  z-index: 100000;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  overflow: hidden;\n  transition: 0.25s width ease; }\n\nh1 {\n  text-align: center;\n  white-space: nowrap; }\n\nh1 a {\n  display: inline-block;\n  cursor: pointer;\n  transition: 0.25s padding,opacity ease; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/home.component.scss
// module id = 200
// module chunks = 1